/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal } from "semantic-ui-react";
import { allFhirResourceTypes } from "../dictionaries/CodeSystemLookup";
import { TextField } from "@mui/material";
import getSearchResults from "../functions/getSearchResultsAPI";
import { useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import CodeEntry from "./CodeEntry";
import ReferenceEntry from "./ReferenceEntry";
import StringEntry from "./StringEntry";
import CodeableConceptEntry from "./CodeableConceptEntry";
import CodingEntry, { CodingEntryWithSystemSelector } from "./CodingEntry";
import AnnotationEntry from "./AnnotationEntry";
import ContactDetailEntry, { ContactPointEntry } from "./ContactDetailEntry";
import IdentifierEntry from "./IdentifierEntry";
import PeriodEntry, { DateEntry, DateTimeEntry } from "./PeriodEntry";
import PositiveIntEntry from "./PositiveIntEntry";
import QuantityEntry from "./QuantityEntry";
import RangeEntry from "./RangeEntry";
import UriEntry from "./UriEntry";
import UsageContextEntry from "./UsageContextEntry";
import AttachmentEntry from "./AttachmentEntry";
import AttesterEntry from "./AttesterEntry";
import DecimalEntry from "./DecimalEntry";
import RelatesToEntry from "./RelatesToEntry";
import ProfileEntry from "./ProfileEntry";
import { RecommendationJustificationComponentEntry } from "../components/RecommendationJustificationEdit";
import RelativeTimeEntry from "./RelativeTimeEntry";
import CodeableReferenceEntry from "./CodeableReferenceEntry";
import { EvidenceVariableCategoryEntry, EvidenceVariableDefinitionModifierEntry } from "../components/EvidenceVariableResourceEdit";
import { EvidenceCertaintyEntry, EvidenceStatisticAttributeEstimateEntry, EvidenceStatisticEntry } from "../components/EvidenceResourceEdit";
import ExtendedContactDetailEntry from "./ExtendedContactDetailEntry";
import AddressEntry from "./AddressEntry";
import HumanNameEntry from "./HumanNameEntry";
import { ListEntryEntry } from "../resourceComponents/ListResourceDisplay";
import { ActivityDefinitionDynamicValueEntry, ActivityDefinitionParticipantEntry } from "../resourceComponents/ActivityDefinitionResourceDisplay";
import { DocumentReferenceContentEntry } from "../resourceComponents/DocumentReferenceResourceDisplay";
import DosageEntry, { DoseAndRateEntry } from "./DosageEntry";
import { PlanDefinitionActionEntry, PlanDefinitionActorEntry, PlanDefinitionGoalEntry } from "../resourceComponents/PlanDefinitionResourceDisplay";
import { MeasureTermEntry } from "../resourceComponents/MeasureResourceDisplay";

const DataEntry = memo(({ datatype, elementName, fieldLabel, startingValue, setResourceState,
    startCollapsed, required, populationQuantity, outcomeCategories, outcomeHandling,
    allowedValues, allowedTypeValues, allowedContentTypes, allowedLanguages, dataEntryStyle,
    doNotShowFieldLabel, inTableCell, startEmptyArrayClosed, storeFalse, resourceType,
    setProfile, selectProfile, selectAnyProfile, addElementValues, addElementValuesArray, generatedNarrative,
    valueSet, asArray, referencedResourceTypes, debug, deletable, deletableArray, enableCreation,
    valueSetForType, startingResourceType, preserveFOI,
    numeratorValueSet, denominatorValueSet, typeValueSet, typeCCValueSet, typeSpecificValueSets, classifierValueSet,
    systemChoices, setSystemChoices, systemChoicesOpen,
    extensionUrl, extensionValueType, classificationProfile, columnHeaders, columnHeader,
    addTableRowModalState, codeableConceptLevelValueSet, foi, contentPath, relatesToClassifierValueSet }) => {
    //console.log("DataEntry CALLED AGAIN");
    switch (datatype) {
        /** 
   case 'SearchPiece':
       return <SearchPieceEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug}
           typeValueSet={typeValueSet} classifierValueSet={classifierValueSet} startCollapsed={startCollapsed} />
         */
        case 'ActivityDefinitionDynamicValue':
            return <ActivityDefinitionDynamicValueEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'ActivityDefinitionParticipant':
            return <ActivityDefinitionParticipantEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />

        case 'Address':
            return <AddressEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /**
         case 'Age':
         return <QuantityEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
             doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={"Age"} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
          */
        case 'Annotation':
            return <AnnotationEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Attachment':
            return <AttachmentEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} allowedContentTypes={allowedContentTypes} allowedLanguages={allowedLanguages} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Attester':
            return <AttesterEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
              case 'boolean':
          return <BooleanEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
              doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} storeFalse={storeFalse} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
      case 'canonical':
          return <UriEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
      case 'Classification':
          return <ClassificationEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
              doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} typeValueSet={typeValueSet} typeSpecificValueSets={typeSpecificValueSets} startCollapsed={startCollapsed} classificationProfile={classificationProfile} />
         */
        case 'code':
            return <CodeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
        case 'CodeableConcept':
            return <CodeableConceptEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} deletable={deletable} debug={debug} systemChoices={systemChoices} systemChoicesOpen={systemChoicesOpen} startCollapsed={startCollapsed} codeableConceptLevelValueSet={codeableConceptLevelValueSet} />
        case 'CodeableReference':
            return <CodeableReferenceEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} systemChoices={systemChoices} systemChoicesOpen={systemChoicesOpen}
                setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues}
                deletable={deletable} debug={debug} referencedResourceTypes={referencedResourceTypes}
                enableCreation={enableCreation} startCollapsed={startCollapsed} />
        /** 
case 'CodeSystemProperty':
return <CodeSystemPropertyEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
   setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} deletable={deletable} debug={debug} referencedResourceTypes={referencedResourceTypes} startCollapsed={startCollapsed} />
case 'CodeSystemConceptDesignation':
return <CodeSystemConceptDesignationEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
   setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} deletable={deletable} debug={debug} referencedResourceTypes={referencedResourceTypes} startCollapsed={startCollapsed} />
*/
        case 'Coding':
            if (systemChoices) {
                return <CodingEntryWithSystemSelector elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                    setResourceState={setResourceState} systemChoices={systemChoices} setSystemChoices={setSystemChoices} systemChoicesOpen={systemChoicesOpen} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
            } else {
                return <CodingEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                    setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
            }
        /** 
        case 'Comment':
        return <CommentEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
    case 'CompositionTableCell':
        return <CompositionTableCellEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} startCollapsed={startCollapsed}
            columnHeader={columnHeader} addTableRowModalState={addTableRowModalState} />
    case 'ConceptDesignation':
        return <ConceptDesignationEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        */
        case 'ContactDetail':
            return <ContactDetailEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'ContactPoint':
            return <ContactPointEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'date':
            return <DateEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'dateTime':
            return <DateTimeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'decimal':
            return <DecimalEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'DocumentReferenceContent':
            return <DocumentReferenceContentEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Dosage':
            return <DosageEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} debug={debug} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} startCollapsed={startCollapsed} allowedValues={allowedValues} deletable={deletable} />
        case 'DoseAndRate':
            return <DoseAndRateEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} debug={debug} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} deletable={deletable} startCollapsed={startCollapsed} />
        /** 
         case 'Duration':
     return <QuantityEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
         doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={"Duration"} inTableCell={inTableCell} debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
    */
        case 'EvidenceStatistic':
            return <EvidenceStatisticEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                populationQuantity={populationQuantity} dataEntryStyle={dataEntryStyle}
                outcomeCategories={outcomeCategories} outcomeHandling={outcomeHandling}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
             case 'EvidenceStatisticSampleSize':
         return <EvidenceStatisticSampleSizeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
             doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
      */
        case 'EvidenceStatisticAttributeEstimate':
            return <EvidenceStatisticAttributeEstimateEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'EvidenceCertainty':
            return <EvidenceCertaintyEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
        case 'EvidenceStatisticModelCharacteristic':
        return <EvidenceStatisticModelCharacteristicEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
    case 'EvidenceStatisticModelCharacteristicVariable':
        return <EvidenceStatisticModelCharacteristicVariableEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} />
   */
        case 'EvidenceVariableCategory':
            return <EvidenceVariableCategoryEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
          case 'EvidenceVariableConstraint':
          return <EvidenceVariableConstraintEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
      case 'EvidenceVariableDataStorage':
          return <EvidenceVariableDataStorageEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
         */
        case 'EvidenceVariableDefinitionModifier':
            return <EvidenceVariableDefinitionModifierEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
          case 'Expression':
          return <ExpressionEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
              doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
  */
        case 'ExtendedContactDetail':
            return <ExtendedContactDetailEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /**
     case 'Extension':
        return <ExtensionEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
     doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} extensionUrl={extensionUrl} extensionValueType={extensionValueType} />
  */
        case 'HumanName':
            return <HumanNameEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /**
case 'id':
    return <IdEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
        doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} />
        */
        case 'Identifier':
            return <IdentifierEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet}
                preserveFOI={preserveFOI} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} startCollapsed={startCollapsed}
                allowedValues={allowedValues} deletable={deletable} />
        /** 
                case 'integer':
            return <IntegerEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        */
        case 'ListEntry':
            return <ListEntryEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed}
                referencedResourceTypes={referencedResourceTypes}
                startingResourceType={startingResourceType}
                setProfile={setProfile}
                selectProfile={selectProfile} />
        case 'MeasureTerm':
            return <MeasureTermEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                setResourceState={setResourceState} />
        case 'Period':
            return <PeriodEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} inTableCell={inTableCell} setResourceState={setResourceState}
                deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        /** 
                case 'PicoSection':
            return <PicoSectionEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
               */
        case 'PlanDefinitionAction':
            return <PlanDefinitionActionEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'PlanDefinitionActor':
            return <PlanDefinitionActorEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'PlanDefinitionGoal':
            return <PlanDefinitionGoalEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Profile':
            return <ProfileEntry elementName={elementName} startingValue={startingValue}
                resourceType={resourceType} setResourceState={setResourceState} />
        /** 
            case 'ProjectAction':
        return <ProjectActionEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
    case 'ProjectActionParameter':
        return <ProjectActionParameterEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
    */
        case 'positiveInt':
            return <PositiveIntEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Quantity':
            return <QuantityEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} valueSet={valueSet} startCollapsed={startCollapsed} deletable={deletable} />
        case 'Range':
            return <RangeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} valueSet={valueSet} deletable={deletable} startCollapsed={startCollapsed} />
        /** 
                case 'Rating':
            return <RatingEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} typeValueSet={typeValueSet} typeSpecificValueSets={typeSpecificValueSets} startCollapsed={startCollapsed} />
        case 'Ratio':
            return <RatioEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} numeratorValueSet={numeratorValueSet} denominatorValueSet={denominatorValueSet} deletable={deletable} startCollapsed={startCollapsed} />
       */
        case 'RecommendationJustificationComponent':
            return <RecommendationJustificationComponentEntry elementName={elementName}
                fieldLabel={fieldLabel} startingValue={startingValue} foi={foi} contentPath={contentPath}
                allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
                debug={debug} deletable={deletable} typeValueSet={typeValueSet} typeCCValueSet={typeCCValueSet}
                typeSpecificValueSets={typeSpecificValueSets} startCollapsed={startCollapsed} />
        /** 
      case 'RecommendationJustificationContent':
      return <RecommendationJustificationContentEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} debug={debug} deletable={deletable} typeValueSet={typeValueSet} typeSpecificValueSets={typeSpecificValueSets} startCollapsed={startCollapsed} />
  case 'ResearchStudyAssociatedParty':
      return <ResearchStudyAssociatedPartyEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyComparisonGroup':
      return <ResearchStudyComparisonGroupEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyLabel':
      return <ResearchStudyLabelEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyObjective':
      return <ResearchStudyObjectiveEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyObjectiveOutcomeMeasure':
      return <ResearchStudyObjectiveOutcomeMeasureEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'Estimand':
      return <EstimandEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'EventHandling':
      return <EventHandlingEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyOutcomeMeasure':
      return <ResearchStudyOutcomeMeasureEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyProgressStatus':
      return <ResearchStudyProgressStatusEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  case 'ResearchStudyRecruitment':
      return <ResearchStudyRecruitmentEntry elementName={elementName} fieldLabel={fieldLabel}
          startingValue={startingValue} setResourceState={setResourceState}
          allowedValues={allowedValues} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
          debug={debug} deletable={deletable} startCollapsed={startCollapsed} />
  */
        case 'Reference':
            return <ReferenceEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState}
                enableCreation={enableCreation} setProfile={setProfile} selectProfile={selectProfile} selectAnyProfile={selectAnyProfile}
                valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} referencedResourceTypes={referencedResourceTypes}
                startingResourceType={startingResourceType} deletable={deletable} debug={debug} startCollapsed={startCollapsed}
                addElementValues={addElementValues} />

        case 'RelatesTo':
            return <RelatesToEntry elementName={elementName} fieldLabel={fieldLabel}
                startingValue={startingValue} setResourceState={setResourceState}
                allowedTypeValues={allowedTypeValues} relatesToClassifierValueSet={relatesToClassifierValueSet}
                startCollapsed={startCollapsed} />
        /** 
           case 'RelatedArtifact':
         return <RelatedArtifactEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
           doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState}
           valueSet={valueSet} debug={debug} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell}
           allowedTypeValues={allowedTypeValues} referencedResourceTypes={referencedResourceTypes}
           deletable={deletable} startCollapsed={startCollapsed} />
             */
        case 'RelativeTime':
            return <RelativeTimeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState}
                doNotShowFieldLabel={doNotShowFieldLabel}
                valueSet={valueSet} debug={debug} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} referencedResourceTypes={referencedResourceTypes}
                deletable={deletable} startCollapsed={startCollapsed} />
        /** 
           case 'SimpleQuantity':
         return <QuantityEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
           doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} dataEntryStyle={"SimpleQuantity"} inTableCell={inTableCell} valueSet={valueSet} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
       */
        case 'string':
            return <StringEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} required={required} debug={debug} startCollapsed={startCollapsed} />
        /*
            case 'StudyAmendment':
          return <StudyAmendmentEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState}
            doNotShowFieldLabel={doNotShowFieldLabel}
            valueSet={valueSet} debug={debug} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} referencedResourceTypes={referencedResourceTypes}
            deletable={deletable} startCollapsed={startCollapsed} />
        case 'time':
          return <TimeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'Timing':
          return <TimingEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'TimingRepeat':
          return <TimingRepeatEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
             case 'unsignedInt':
          return <UnsignedIntEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
            doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
              */
        case 'uri':
            return <UriEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
        case 'UsageContext':
            return <UsageContextEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue}
                doNotShowFieldLabel={doNotShowFieldLabel} setResourceState={setResourceState} valueSet={valueSet} dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} allowedValues={allowedValues} referencedResourceTypes={referencedResourceTypes} deletable={deletable} debug={debug} valueSetForType={valueSetForType} startCollapsed={startCollapsed} />
        /*
        case 'ValueSetCompose':
      return <ValueSetComposeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
    case 'ValueSetComposeInclude':
      return <ValueSetComposeIncludeEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
      case 'ValueSetComposeIncludeConcept':
      return <ValueSetComposeIncludeConceptEntry elementName={elementName} fieldLabel={fieldLabel} startingValue={startingValue} setResourceState={setResourceState} deletable={deletable} debug={debug} startCollapsed={startCollapsed} />
    */
        default:
            return <>OOPS!  DataEntry datatype NOT recognized!</>
    }
});

const SelectMultipleResourcesFromSearchModal = memo(({ allowedResourceTypes,
    selectMultipleResourcesFromSearchState, setSelectMultipleResourcesFromSearchState }) => {

    let startingModalState = { "modalOpen": true, "searchQueryString": "", "searchResults": "" }
    const [modalState, setModalState] = useState(startingModalState);
    const [searchResourceTypeLimiterState, setSearchResourceTypeLimiterState] = useState({
        "selectedResourceTypes": allowedResourceTypes
    });

    const apiToken = useSelector(selectCurrentUserApiToken);
    const deliverSearchResults = useCallback(async () => {
        if (modalState.modalOpen && modalState.searchQueryString &&
            modalState.searchQueryCompleted && !modalState.searchResultsDelivered) {
            let searchResults = await getSearchResults(modalState.searchQueryString,
                null,
                searchResourceTypeLimiterState.selectedResourceTypes,
                null,
                [],
                apiToken);
            setModalState(prevState => {
                return { ...prevState, "searchResults": searchResults, "searchResultsDelivered": true }
            })
        }
    }, [apiToken, modalState, searchResourceTypeLimiterState.selectedResourceTypes]);

    useEffect((() => {
        deliverSearchResults();
    }), [deliverSearchResults, modalState])

    const selectTheResource = (data) => {
        let newArray = selectMultipleResourcesFromSearchState.selectedResourcesArray;
        newArray.push(data);
        setSelectMultipleResourcesFromSearchState(prevState => {
            return { ...prevState, "selectedResourcesArray": newArray };
        });
    }

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }} className="formButton negative"
            content="✖"
            onClick={() => {
                setModalState(prevState => { return { ...prevState, modalOpen: false }; });
                setSelectMultipleResourcesFromSearchState(prevState => { return { ...prevState, modalOpen: false, applySelection: true }; });
            }} />
        <ArrayEntry datatype='code' elementName='selectedResourceTypes' fieldLabel='Limit by Resource Type'
            allowedValues={(allowedResourceTypes && allowedResourceTypes.length) ? allowedResourceTypes : allFhirResourceTypes} dataEntryStyle='dropdownsearch'
            startingValue={searchResourceTypeLimiterState.selectedResourceTypes || []}
            setResourceState={setSearchResourceTypeLimiterState} />
        <p style={{ paddingTop: "12px" }}>Limit to resource types of: {(searchResourceTypeLimiterState.selectedResourceTypes &&
            searchResourceTypeLimiterState.selectedResourceTypes.length > 0) ?
            searchResourceTypeLimiterState.selectedResourceTypes.join(', ') : "[No limits]"}</p>
        <br />
        <h3>Enter search string</h3>
        <TextField style={{ width: "100%", marginTop: "16px" }}
            className="inputField" type='text' label={"Enter search string"} size="small" variant='outlined'
            value={modalState.searchQueryString || ""}
            onKeyUp={(event) => {
                if (event.key === 'Enter') {
                    setModalState(prevState => { return { ...prevState, "searchQueryCompleted": true, "searchResultsDelivered": false } });
                }
            }}
            onChange={(e) => {
                setModalState(prevState => { return { ...prevState, "searchQueryString": e.target.value } })
            }} />
        {modalState.searchResults && <>
            <h3>Select resources</h3>
            <h4>{selectMultipleResourcesFromSearchState.selectedResourcesArray.length} resources selected. Click the x (top right corner), then click Update on the left panel, to complete.</h4>
            {modalState.searchResults.length > 0
                ?
                <>
                    {modalState.searchResults.map((result, resultIndex) => {
                        return <p key={resultIndex}>
                            <span style={{ cursor: "pointer" }}
                                onClick={() => {
                                    selectTheResource(result.data);
                                }} ><b>SELECT</b></span>
                            &nbsp;&nbsp;
                            <span >{result.display}</span>
                            &nbsp;&nbsp;
                            <a href={"https://fevir.net" + result.onClick} target='_blank' rel='noopener noreferrer' >View on FEvIR</a>
                        </p>
                    })}
                </>
                :
                <>No results found.</>}
        </>
        }
        <br />
    </div>;

    return <Modal
        style={{ padding: "0px", margin: "0px" }}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        open={modalState?.modalOpen}
        centered={false}
        content={modalContent}
    />;
})

const ArrayEntry = memo(({ datatype, elementName, fieldLabel, startingValue, setResourceState,
    addElementValues, addElementValuesArray, allowedValues, codeableConceptLevelValueSet,
    populationQuantity, outcomeCategories, outcomeHandling, preserveFOI,
    allowedTypeValues, allowedContentTypes, allowedLanguages, dataEntryStyle, inTableCell, valueSet, referencedResourceTypes,
    debug, deletable, deletableArray, doNotShowFieldLabel, typeValueSet, typeCCValueSet,
    classifierValueSet, systemChoices, setSystemChoices, systemChoicesOpen,
    startEmptyArrayClosed, typeSpecificValueSets, startCollapsed, startingResourceType, extensionUrl,
    extensionValueType, classificationProfile, enableCreation, resourceType, setProfile, selectProfile,
    selectAnyProfile, foi, contentPath, relatesToClassifierValueSet }) => {
    //console.log("ArrayEntry CALLED AGAIN");
    let showDataEntry = true;
    if (!startingValue && startEmptyArrayClosed) {
        showDataEntry = false;
    }
    const calculateStartingArrayAsObject = useCallback(() => {
        let startingArrayAsObject = {};
        if (startingValue) {
            for (let itemIndex in startingValue) {
                startingArrayAsObject[itemIndex] = startingValue[itemIndex];
            }
        }
        return startingArrayAsObject;
    }, [startingValue]);
    const startingArrayAsObject = useMemo(() => calculateStartingArrayAsObject(), [calculateStartingArrayAsObject])

    const [arrayState, setArrayState] = useState(JSON.parse(JSON.stringify(startingArrayAsObject || {})));
    const [undoArrayState, setUndoArrayState] = useState(null);
    const [showDataEntryState, setShowDataEntryState] = useState(showDataEntry);
    const [selectMultipleResourcesFromSearchState, setSelectMultipleResourcesFromSearchState] = useState({
        "modalOpen": false, "selectedResourcesArray": []
    });

    useEffect(() => {
        if (selectMultipleResourcesFromSearchState.selectedResourcesArray.length > 0 &&
            selectMultipleResourcesFromSearchState.applySelection) {
            let initialArray = startingValue || [];
            let newArray = initialArray.concat(selectMultipleResourcesFromSearchState.selectedResourcesArray);
            setResourceState(prevState => { return { ...prevState, [elementName]: newArray } });
        }
    }, [selectMultipleResourcesFromSearchState]);

    useEffect((() => {
        if (Object.keys(arrayState).length &&
            JSON.stringify(startingArrayAsObject) !== JSON.stringify(arrayState)) {
            let newArray = [];
            for (let key of Object.keys(arrayState)) {
                if (arrayState[key] !== null &&
                    !(typeof arrayState[key] === "object" && Object.keys(arrayState[key]).length === 0) &&
                    !(Array.isArray(arrayState[key]) && arrayState[key].length === 0) &&
                    arrayState[key] !== "" &&
                    arrayState[key] !== undefined && arrayState[key] !== "DELETEME") {
                    newArray.push(arrayState[key]);
                }
            }
            if (newArray.length > 0) {
                setResourceState(prevState => { return { ...prevState, [elementName]: newArray } });
            } else {
                setResourceState(prevState => { return { ...prevState, [elementName]: null } });
            }
            if (undoArrayState && (Object.keys(arrayState).length !== 1 || (Object.keys(arrayState).length === 1 && arrayState['0'] !== "DELETEME"))) {
                setUndoArrayState(null);
            }
        }
    }), [arrayState]);

    useEffect(() => {
        if (undoArrayState) {
            setArrayState({ '0': "DELETEME" });
        }
    }, [undoArrayState]);

    return <div>
        {(showDataEntryState === false || doNotShowFieldLabel ||
            (inTableCell && Object.entries(arrayState).length > 0))
            ? <></> :
            <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>}
        {showDataEntryState === false &&
            <Button className="formButton" style={{ color: "#000000", marginBottom: "12px" }} content={"+ Add " + fieldLabel}
                onClick={() => {
                    setArrayState(prevState => {
                        let arrayLength = Object.keys(prevState).length;
                        let arrayIndexNumber = arrayLength.toString();
                        if (prevState['0'] === null) {
                            arrayIndexNumber = '1';
                        }
                        return {
                            ...prevState,
                            //['0']: prevState['0'] || "",
                            [arrayIndexNumber]: ""
                        };
                    });
                    if (!showDataEntryState) {
                        setShowDataEntryState(true);
                    }
                }} />}
        <div style={{ marginLeft: (doNotShowFieldLabel || inTableCell) ? "0px" : "24px" }}>
            {showDataEntryState === true && Object.entries(arrayState).map((keyValuePair, keyValuePairIndex) => {
                return <div key={keyValuePairIndex}
                    style={{ marginBottom: doNotShowFieldLabel ? "6px" : "0px" }}>
                    {keyValuePair[1] === "DELETEME" ?
                        <>
                            <p style={{ marginBottom: "0px" }}><b>{fieldLabel + ' entry ' + (keyValuePairIndex + 1)}: </b></p>
                            <div style={{ marginLeft: "24px" }}>WILL BE DELETED.</div>
                        </>
                        :
                        <>
                            <p style={{ marginBottom: "0px" }}>
                                <b>{fieldLabel + ' entry ' + (keyValuePairIndex + 1)}: </b>
                                {deletable && <span style={{ marginLeft: "24px" }}>
                                    &nbsp;&nbsp;
                                    <Button className="formButton" style={{ color: "#000000" }}
                                        content={"x Delete"}
                                        onClick={() => {
                                            setArrayState(prevState => {
                                                return {
                                                    ...prevState,
                                                    [keyValuePairIndex.toString()]: "DELETEME"
                                                };
                                            });
                                        }} />
                                </span>}
                            </p>
                            <div style={{ marginLeft: "24px" }}>
                                <DataEntry datatype={datatype} elementName={keyValuePair[0]}
                                    enableCreation={enableCreation} preserveFOI={preserveFOI}
                                    doNotShowFieldLabel={true} resourceType={resourceType}
                                    codeableConceptLevelValueSet={codeableConceptLevelValueSet}
                                    populationQuantity={populationQuantity} outcomeCategories={outcomeCategories} outcomeHandling={outcomeHandling}
                                    fieldLabel={doNotShowFieldLabel || Object.entries(arrayState).length > 1 ? fieldLabel + ' entry ' + (keyValuePairIndex + 1) : fieldLabel} classificationProfile={classificationProfile}
                                    startingValue={keyValuePair[1]} setResourceState={setArrayState} allowedValues={allowedValues}
                                    dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} valueSet={valueSet} referencedResourceTypes={referencedResourceTypes}
                                    debug={debug} allowedContentTypes={allowedContentTypes} allowedLanguages={allowedLanguages}
                                    startCollapsed={keyValuePair[1] && startCollapsed} startingResourceType={startingResourceType}
                                    systemChoices={systemChoices} setSystemChoices={setSystemChoices} systemChoicesOpen={systemChoicesOpen}
                                    typeSpecificValueSets={typeSpecificValueSets}
                                    addElementValues={addElementValues || addElementValuesArray?.[keyValuePair[0]]}
                                    allowedTypeValues={allowedTypeValues} deletable={deletable} typeValueSet={typeValueSet}
                                    typeCCValueSet={typeCCValueSet} foi={foi} contentPath={contentPath}
                                    classifierValueSet={classifierValueSet} extensionUrl={extensionUrl} extensionValueType={extensionValueType}
                                    setProfile={setProfile} selectProfile={selectProfile} selectAnyProfile={selectAnyProfile}
                                    relatesToClassifierValueSet={relatesToClassifierValueSet} />
                            </div>
                        </>
                    }
                </div>
            })}
            <div style={{ marginBottom: "12px" }}>
                {showDataEntryState === true && <>
                    <Button className="formButton" style={{ color: "#000000" }} content={"+ Add " + fieldLabel}
                        onClick={() => {
                            setArrayState(prevState => {
                                let arrayLength = Object.keys(prevState).length;
                                let arrayIndexNumber = arrayLength.toString();
                                if (prevState['0'] === null) {
                                    arrayIndexNumber = '1';
                                }
                                return {
                                    ...prevState,
                                    //['0']: prevState['0'] || "",
                                    [arrayIndexNumber]: ""
                                };
                            });
                            if (!showDataEntryState) {
                                setShowDataEntryState(true);
                            }
                        }} />
                </>}
                {datatype === "Reference" && <><br />
                    <Button className="formButton" style={{ color: "#000000" }}
                        content={"Search Resources to Add Multiple " + fieldLabel + " Entries"}
                        onClick={() => { setSelectMultipleResourcesFromSearchState({ "modalOpen": true, "selectedResourcesArray": [] }); }}
                    />
                </>}
                {selectMultipleResourcesFromSearchState.modalOpen &&
                    <SelectMultipleResourcesFromSearchModal allowedResourceTypes={referencedResourceTypes}
                        selectMultipleResourcesFromSearchState={selectMultipleResourcesFromSearchState}
                        setSelectMultipleResourcesFromSearchState={setSelectMultipleResourcesFromSearchState} />}
                {(deletableArray && showDataEntryState === true && Object.keys(arrayState).length !== 0) &&
                    <Button className="formButton" style={{ color: "#000000" }} content={"Delete All " + fieldLabel + " Entries"}
                        onClick={() => {
                            alert('Deletion will remove all data in this list. When you click Update, the data will be deleted. If you do not want to delete, refresh the page to lose all your edits instead of clicking Update.');
                            setUndoArrayState(arrayState);
                            //setArrayState({ '0': null });
                        }} />}
                {undoArrayState && <Button className="formButton" style={{ color: "#000000", marginLeft: "2px" }} content={"Undo Deletion"}
                    onClick={() => { setArrayState(undoArrayState); }} />}
            </div>
        </div>
    </div>
});

export default ArrayEntry;